export const RETURN_RULES_CREATE_RULE = 'RETURN_RULES_CREATE_RULE'
export const RETURN_RULES_DELETE_RULE = 'RETURN_RULES_DELETE_RULE'
export const RETURN_RULES_FETCH_RULE = 'RETURN_RULES_FETCH_RULE'
export const RETURN_RULES_FETCH_RULES = 'RETURN_RULES_FETCH_RULES'
export const RETURN_RULES_MOVE_RULES = 'RETURN_RULES_MOVE_RULES'
export const RETURN_RULES_TOGGLE_RULE = 'RETURN_RULES_TOGGLE_RULE'
export const RETURN_RULES_UPDATE_RULE = 'RETURN_RULES_UPDATE_RULE'
